import React from 'react'

const FormLayout = ({ children }) => {
  return <div className="form-layout">{children}</div>
}

export default FormLayout
